import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// Profile & Dashboard
export const getProfileSessions = () => api.get("/profile/sessions");
export const getProfileStats = () => api.get("/profile/stats");
export const getDashboardOverview = () => api.get("/dashboard/overview");
export const getLeaderboard = (roleId) => api.get("/leaderboard", { params: roleId ? { role_id: roleId } : {} });

// Scenario & Knowledge
export const getScenarios = () => api.get("/scenarios");
export const getScenario = (scenarioId) => api.get("/scenario", { params: scenarioId ? { scenario_id: scenarioId } : {} });
export const getPersonas = (scenarioId) => api.get("/personas", { params: scenarioId ? { scenario_id: scenarioId } : {} });

// Simulation
export const startSimulation = (scenarioId = "akamai_jfs", roleId = null, startingPersona = null) =>
  api.post("/simulation/start", { scenario_id: scenarioId, role_id: roleId, starting_persona: startingPersona });

export const sendMessage = (sessionId, message) =>
  api.post("/simulation/chat", { 
    session_id: sessionId, 
    message
  });

export const getSimulationState = (sessionId) =>
  api.get(`/simulation/${sessionId}/state`);

export const endSimulation = (sessionId) =>
  api.post(`/simulation/${sessionId}/end`);

export const getReport = (sessionId) =>
  api.get(`/simulation/${sessionId}/report`);

export const acknowledgeCoach = (sessionId, interventionId) =>
  api.post(`/simulation/${sessionId}/acknowledge-coach?intervention_id=${interventionId}`);

export const pollCoachFeedback = (sessionId) =>
  api.get(`/simulation/${sessionId}/coach-poll`);

export const getSuggestion = (sessionId, quality) =>
  api.post(`/simulation/${sessionId}/suggestions`, { quality });

export const voiceChat = (sessionId, audioBlob) => {
  const formData = new FormData();
  formData.append("audio", audioBlob, "recording.webm");
  return api.post(`/simulation/${sessionId}/voice-chat`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 60000,
  });
};

export const textToSpeech = (text, personaId) =>
  api.post("/tts", { text, persona_id: personaId });

export const testVoiceChat = (sessionId, quality) =>
  api.post(`/simulation/${sessionId}/test-voice`, { quality }, { timeout: 60000 });

// Multi-stakeholder endpoints
export const getInterimSummary = (sessionId) =>
  api.post(`/simulation/${sessionId}/interim-summary`);

export const switchPersona = (sessionId, targetPersona) =>
  api.post(`/simulation/${sessionId}/switch-persona`, { target_persona: targetPersona });

// Replay
export const getSessionReplay = (sessionId) =>
  api.get(`/simulation/${sessionId}/replay`);

// Persona avatars: initials-based (no stock photos for fictional personas)
export const PERSONA_IMAGES = {};

// MEDDPICC dimension info with Akamai palette colors
export const MEDDPICC_LABELS = {
  M: { name: "Metrics", color: "#002856" },
  E: { name: "Economic Buyer", color: "#753BBD" },
  D1: { name: "Decision Criteria", color: "#D0343A" },
  D2: { name: "Decision Process", color: "#FF9933" },
  P: { name: "Paper Process", color: "#54565B" },
  I: { name: "Identify Pain", color: "#009CDE" },
  C1: { name: "Champion", color: "#00B050" },
  C2: { name: "Competition", color: "#0a3050" },
};

// Phase info (generic fallback — scenario-specific names via personaCatalog.getPhaseName)
export const PHASE_INFO = {
  P1: { name: "Discovery", color: "blue" },
  P2: { name: "Qualification", color: "purple" },
  P3: { name: "Validation & Proposal", color: "amber" },
  P4: { name: "Commitment & Closure", color: "emerald" },
  COMPLETE: { name: "Complete", color: "green" },
  FAILED: { name: "Failed", color: "red" },
};

// Trust level info
export const getTrustLevel = (score) => {
  if (score <= 40) return { level: "Defensive", color: "red" };
  if (score <= 60) return { level: "Neutral", color: "yellow" };
  if (score <= 80) return { level: "Engaged", color: "emerald" };
  return { level: "Advocate", color: "blue" };
};
